import { supabase } from '@/lib/supabase'

// Admin-only Shopify discount management, proxied through the
// shopify-discounts edge function so the Admin API token never reaches the
// browser. Every call rides on the signed-in admin's Supabase JWT.

// The share link is a public marketing URL — always the production apex
// domain, regardless of which host the admin is on.
export const discountShareLink = (code) => `https://getdub.com/discount/${code}`

async function call(body) {
  const { data, error } = await supabase.functions.invoke('shopify-discounts', { body })
  if (error) {
    // Supabase wraps non-2xx responses; surface the function's own message
    // (and the setup flag) when we can read it.
    let parsed = null
    try {
      parsed = await error.context?.json()
    } catch { /* not JSON */ }
    if (parsed?.setupRequired) return { setupRequired: true }
    throw new Error(parsed?.error || error.message || 'Request failed')
  }
  if (data?.setupRequired) return { setupRequired: true }
  if (data?.error) throw new Error(data.error)
  return data
}

export const fetchDiscounts = () => call({ action: 'list' })

// ACTIVE Shopify products ({ id, title }) for the New Code "applies to" list.
export const fetchActiveProducts = () => call({ action: 'products' })

// payload: { code, kind: 'percentage'|'amount'|'free_shipping', value,
//            endsAt (ISO|null), usageLimit (int|null), oncePerCustomer,
//            productIds (Shopify Product GIDs; empty/omitted = all products) }
export const createDiscount = (payload) => call({ action: 'create', payload })

export const activateDiscount = (id) => call({ action: 'activate', id })
export const deactivateDiscount = (id) => call({ action: 'deactivate', id })
export const deleteDiscount = (id) => call({ action: 'delete', id })
